import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    Box,
    Divider,
    Stack,
    FormControl,
    Select,
    MenuItem,
    InputLabel,
} from '@mui/material';
import AddReactionOutlinedIcon from '@mui/icons-material/AddReactionOutlined';
import { useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import StatusApi from '../../api/user/update_status.ts';
import UpdateUser from '../../api/user/update_user.ts';
import Signup from '../signup/Signup.jsx';
import UserRow from './UserRow.jsx';
import { update_status } from '../../slices/usersDataSlice.js';
import ImageLoading from '../../components/alert/imageLoading.js';

const Users = () => {
    const dispatch = useDispatch();
    const { data: users, loading } = useSelector((state) => state.users);
    const typeUser = useSelector((state) => state.typeUser.data);
    const dataType = useSelector((state) => state.dataTypes.data);
    const [editingId, setEditingId] = useState(null);
    const [openSignup, setOpenSignup] = useState(false);
    const [status_id, setStatus] = useState(0);
    const [formData, setFormData] = useState({
        id_user: '',
        document: '',
        name: '',
        phone: '',
        email: '',
        date_birth: '',
        gender: '',
        office_id: '',
        city_id: '',
    });

    const handleStatus = async (userId, currentStatus) => {

        const newStatusText = currentStatus === 'ACTIVO' ? 'INACTIVO' : 'ACTIVO';
        const newStatusId = currentStatus === 'ACTIVO' ? 10 : 8;

        dispatch(update_status({ userId, newStatus: newStatusText }));

        const response = await StatusApi({ id_user: userId, status_id: newStatusId });

        if (response.data.success !== 200) {
            dispatch(update_status({ userId, newStatus: currentStatus }));
        }
    };

    const startEdit = useCallback((user) => {
        setEditingId(user.id_user);
        setFormData({ ...user });
    }, []);

    const cancelEdit = () => {
        setEditingId(null);
        setFormData({});
    };

    const saveEdit = async () => {
        try {
            const response = await UpdateUser(formData);
            if (response.success || response.status === 200) {
                setEditingId(null);
            }
        } catch (error) {
            console.error("Error updating user:", error);
        }
    };

    const handleInputChange = useCallback((e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    }, []);

    const handleOpen = () => setOpenSignup(true);
    const handleCloseSignup = () => setOpenSignup(false);

    const handlestatusChange = async (e) => {
        setStatus(e.target.value);
    };

    const filteredUsers = users.filter((user) => {
        switch (status_id) {
            case 8:
                return user.status === 'ACTIVO';
            case 10:
                return user.status === 'INACTIVO';
            default:
                return user;
        }
    });
    const isEditing = (userId) => editingId === userId;

    return (
        <Box sx={{ maxWidth: '100%', overflowX: 'auto' }}>
            <Signup open={openSignup} onClose={handleCloseSignup} />

            <Stack
                direction={{ xs: 'column', sm: 'row' }}
                divider={<Divider orientation="vertical" flexItem sx={{ mx: 1, borderColor: 'primary.main', display: { xs: 'none', sm: 'block' } }} />}
                spacing={2}
                sx={{ mb: 3 }}
            >
                <Button
                    variant="contained"
                    size="large"
                    startIcon={<AddReactionOutlinedIcon />}
                    onClick={handleOpen}
                >
                    Nuevo Usuario
                </Button>

                <FormControl sx={{ minWidth: { xs: '100%', sm: 200 }, ml: { xs: 0, sm: 2 } }} size="small">
                    <InputLabel>Filtrar por estado</InputLabel>
                    <Select
                        value={status_id}
                        label="Filtrar por estado"
                        onChange={handlestatusChange}
                    >
                        <MenuItem value={0}>
                            <em>-- Todos --</em>
                        </MenuItem>
                        {dataType
                            .filter(item => [8, 10].includes(item.id_type_data))
                            .map(item => (
                                <MenuItem key={item.id_type_data} value={item.id_type_data}>
                                    {item.name}
                                </MenuItem>
                            ))}
                    </Select>
                </FormControl>
            </Stack>

            <TableContainer component={Paper} sx={{ mt: 3, boxShadow: 3, borderRadius: 2, overflowX: 'auto', maxWidth: '100%', maxHeight: 600 }}>
                <Table sx={{ minWidth: 650 }} aria-label="users table">
                    <TableHead sx={{ bgcolor: 'primary.main' }}>
                        <TableRow>
                            <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Documento</TableCell>
                            <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Tipo</TableCell>
                            <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Nombres</TableCell>
                            <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Teléfono</TableCell>
                            <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Correo</TableCell>
                            <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Fecha Nac.</TableCell>
                            <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Género</TableCell>
                            <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Ciudad</TableCell>
                            <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Oficina</TableCell>
                            <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Estado</TableCell>
                            <TableCell align="center" sx={{ color: 'white', fontWeight: 'bold' }} colSpan={2}>
                                Acciones
                            </TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {filteredUsers.map(user => (
                            <UserRow
                                key={user.id_user}
                                user={user}
                                isEditing={isEditing(user.id_user)}
                                formData={formData}
                                handleInputChange={handleInputChange}
                                startEdit={startEdit}
                                cancelEdit={cancelEdit}
                                saveEdit={saveEdit}
                                handleStatus={handleStatus}
                            />
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            {loading && <ImageLoading />}
        </Box>
    );
};

export default Users;